import {registry} from 'ui/registry';

export const registerMainPlugins = () => {
    registry.main.components.registerMany({});
};
